var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:{treeView: _vm.treeView}},[_c('router-link',{attrs:{"to":_vm.item.url}},[_c('span',{staticClass:"menu-icon"},[_c('span',{class:_vm.item.menuIcon})]),_c('span',[_vm._v(_vm._s(_vm.item.menuName))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }